import init from "../../common/base/init"

const NON_BUSINESS_EMAILS = [
  "@mac.com",
  "@gmail.com",
  "@yahoo.com",
  "@hotmail.com",
  "@outlook.com",
  "@live.com",
  "@aol.com",
  "@msn.com",
]

init(() => {
  Array.prototype.forEach.call(document.querySelectorAll(".js-company-email"), (el) => {
    el.addEventListener("input", (e) => {
      let privateEmail = false

      NON_BUSINESS_EMAILS.map((text) => {
        if (e.target.value.indexOf(text) !== -1) {
          privateEmail = text
          createInputError(el);
        } else {
          if (privateEmail) return;
          removeInputError(el);
        }
      })
    })
  })
})

const createInputError = (el) => {
  const errorWrapperEl = document.createElement("div")
  errorWrapperEl.innerHTML = "Är du säker på att detta är din företags e-post?";
  errorWrapperEl.classList.add('lx-input-error');

  el.parentNode.appendChild(errorWrapperEl);
}

const removeInputError = (el) => {
  if (el.parentNode.querySelector('.lx-input-error')) {
    el.parentNode.querySelector('.lx-input-error').remove();
  }
}
